// extracted by mini-css-extract-plugin
export default {"draftBillingDialog":"ByMy2","submissionMessage":"bixAI"};